import LegalShell, { Section } from "@/components/LegalShell";

export default function Datenschutz() {
  return (
    <LegalShell testId="datenschutz-page" eyebrow="Rechtliches" title="Datenschutzerklärung" updated="Juli 2026">
      <p>
        Wir freuen uns über Ihr Interesse an FestivalPlan. Der Schutz Ihrer personenbezogenen Daten
        ist uns ein wichtiges Anliegen. In dieser Datenschutzerklärung informieren wir Sie darüber,
        welche personenbezogenen Daten bei der Nutzung unserer Website und der mobilen Anwendung
        FestivalPlan verarbeitet werden.
      </p>

      <Section title="1. Verantwortlicher">
        <p>Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO):</p>
        <p>Sebastian Menzel</p>
        <p>
          Die Anschrift wird aus Datenschutzgründen nicht öffentlich angegeben. Bei Fragen zum
          Datenschutz kontaktiere uns bitte per E-Mail:
        </p>
        <p>
          E-Mail: <a href="mailto:privacy@festivalplan.app" className="text-[#00E5FF]">privacy@festivalplan.app</a><br />
          Support: <a href="mailto:support@festivalplan.app" className="text-[#00E5FF]">support@festivalplan.app</a><br />
          Website: <a href="https://festivalplan.app" className="text-[#00E5FF]">https://festivalplan.app</a>
        </p>
      </Section>

      <Section title="2. Allgemeine Hinweise">
        <p>
          Wir behandeln personenbezogene Daten vertraulich und entsprechend der gesetzlichen
          Datenschutzvorschriften sowie dieser Datenschutzerklärung. Personenbezogene Daten werden
          grundsätzlich nur verarbeitet, soweit dies zur Bereitstellung unserer Dienste erforderlich
          ist oder Sie ausdrücklich eingewilligt haben.
        </p>
      </Section>

      <Section title="3. Welche Daten werden verarbeitet?">
        <p>Je nach Nutzung der App können unter anderem folgende Daten verarbeitet werden:</p>
        <p className="text-white/80">Kontodaten</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Anzeigename</li>
          <li>E-Mail-Adresse</li>
          <li>Passwörter werden ausschließlich in gehashter Form gespeichert und können nicht im Klartext eingesehen werden.</li>
          <li>Profilbild (optional)</li>
        </ul>
        <p className="text-white/80">Nutzungsdaten</p>
        <p>Innerhalb der App können folgende Inhalte gespeichert werden:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Gruppen</li>
          <li>Gruppenmitglieder</li>
          <li>Chatnachrichten</li>
          <li>Aufgaben</li>
          <li>Mitbringlisten</li>
          <li>Fahrgemeinschaften</li>
          <li>Gruppenkassen-Einträge</li>
          <li>Benutzeraktionen</li>
          <li>Push-Einstellungen</li>
        </ul>
        <p className="text-white/80">Hochgeladene Bilder</p>
        <p>
          Profilbilder und Gruppenbilder werden ausschließlich gespeichert, wenn Nutzer diese
          freiwillig hochladen. Der Zugriff auf die Fotobibliothek erfolgt ausschließlich nach
          ausdrücklicher Zustimmung des Nutzers. FestivalPlan greift nicht auf die Kamera zu.
        </p>
      </Section>

      <Section title="4. Registrierung">
        <p>
          Zur Nutzung der App ist die Erstellung eines Benutzerkontos erforderlich. Die Registrierung
          erfolgt ausschließlich über E-Mail-Adresse und Passwort. Die bereitgestellten Daten werden
          ausschließlich zur Bereitstellung des Benutzerkontos verwendet.
        </p>
      </Section>

      <Section title="5. Login">
        <p>
          Nach erfolgreicher Registrierung wird ein Benutzerkonto erstellt. Zur Authentifizierung
          werden sichere Zugangstoken verwendet. Passwörter werden nicht im Klartext gespeichert.
        </p>
      </Section>

      <Section title="6. Gruppenfunktionen">
        <p>
          FestivalPlan ermöglicht die Erstellung gemeinsamer Gruppen. Dabei können Nutzer unter
          anderem:
        </p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Mitglieder einladen</li>
          <li>Aufgaben verwalten</li>
          <li>Chatnachrichten austauschen</li>
          <li>Mitbringlisten organisieren</li>
          <li>Fahrgemeinschaften planen</li>
          <li>gemeinsame Ausgaben verwalten</li>
        </ul>
        <p>Diese Daten sind ausschließlich für Mitglieder der jeweiligen Gruppe sichtbar.</p>
      </Section>

      <Section title="7. Standortdaten">
        <p>
          FestivalPlan verarbeitet Standortdaten ausschließlich dann, wenn du die Funktion
          „Weg aufzeichnen" oder die Kartenfunktion aktiv nutzt. Im Einzelnen gilt:
        </p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>
            Dein Standort wird nur nach deiner ausdrücklichen Zustimmung erfasst. Rechtsgrundlage ist
            deine Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
          </li>
          <li>Es findet keine permanente Standortüberwachung und kein Tracking im Hintergrund statt.</li>
          <li>
            Standortdaten werden ausschließlich zur Aufzeichnung von Laufwegen, zur Berechnung der
            Wegstrecke sowie zum Setzen von Markern verwendet.
          </li>
          <li>
            Die gespeicherten Wege und Marker sind ausschließlich für Mitglieder der jeweiligen Gruppe
            sichtbar.
          </li>
          <li>Standortdaten werden nicht an Dritte weitergegeben und nicht für Werbezwecke genutzt.</li>
          <li>
            Die Standortfreigabe kann jederzeit in den Einstellungen deines Geräts widerrufen werden;
            die Aufzeichnung wird dann unmittelbar beendet.
          </li>
        </ul>
      </Section>

      <Section title="8. Push-Benachrichtigungen">
        <p>FestivalPlan kann Push-Benachrichtigungen senden. Beispielsweise bei:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>neuen Chatnachrichten</li>
          <li>neuen Aufgaben</li>
          <li>Änderungen innerhalb einer Gruppe</li>
          <li>neuen Mitbringlisten</li>
          <li>Gruppeneinladungen</li>
        </ul>
        <p>
          Push-Benachrichtigungen können jederzeit in den Einstellungen des Betriebssystems
          deaktiviert werden.
        </p>
      </Section>

      <Section title="9. Kontaktformular">
        <p>Wenn Sie unser Kontaktformular nutzen, werden folgende Daten verarbeitet:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>Nachricht</li>
        </ul>
        <p>Die Verarbeitung erfolgt ausschließlich zur Bearbeitung Ihrer Anfrage.</p>
      </Section>

      <Section title="10. Server-Logfiles">
        <p>
          Beim Besuch unserer Website können automatisch technische Informationen verarbeitet werden.
          Hierzu gehören insbesondere:
        </p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>IP-Adresse</li>
          <li>Browsertyp</li>
          <li>Betriebssystem</li>
          <li>Datum und Uhrzeit</li>
          <li>aufgerufene Seiten</li>
        </ul>
        <p>
          Diese Daten dienen ausschließlich der technischen Bereitstellung und Sicherheit der Website.
          Diese Daten werden nicht mit anderen personenbezogenen Daten zusammengeführt.
        </p>
      </Section>

      <Section title="11. Hosting">
        <p>
          Zur Bereitstellung der App und der zugehörigen Dienste nutzt FestivalPlan Cloud-Dienste.
          Dabei können personenbezogene Daten auf Servern der jeweiligen Anbieter verarbeitet und
          gespeichert werden. Die Verarbeitung erfolgt ausschließlich zur Bereitstellung der Anwendung.
        </p>
      </Section>

      <Section title="12. Cloudflare">
        <p>Für die Bereitstellung der Website nutzen wir Cloudflare. Cloudflare dient insbesondere:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>der sicheren Bereitstellung der Website</li>
          <li>der Verbesserung der Ladegeschwindigkeit</li>
          <li>dem Schutz vor Angriffen</li>
        </ul>
        <p>
          Dabei können technische Verbindungsdaten verarbeitet werden. Weitere Informationen finden
          Sie unter:{" "}
          <a href="https://www.cloudflare.com/privacy/" target="_blank" rel="noreferrer" className="text-[#00E5FF]">
            https://www.cloudflare.com/privacy/
          </a>
        </p>
      </Section>

      <Section title="13. Datensicherheit">
        <p>
          Wir setzen technische und organisatorische Maßnahmen ein, um Ihre personenbezogenen Daten
          vor Verlust, Manipulation und unberechtigtem Zugriff zu schützen. Die Kommunikation zwischen
          App und Server erfolgt verschlüsselt.
        </p>
      </Section>

      <Section title="14. Speicherdauer">
        <p>Personenbezogene Daten werden nur solange gespeichert, wie dies:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>für die Nutzung der App,</li>
          <li>aufgrund gesetzlicher Aufbewahrungspflichten</li>
          <li>oder zur Erfüllung vertraglicher Verpflichtungen</li>
        </ul>
        <p>erforderlich ist.</p>
      </Section>

      <Section title="15. Löschung des Benutzerkontos">
        <p>
          Nutzer können ihr Benutzerkonto jederzeit direkt in der App über den Bereich „Profil" löschen
          oder alternativ über die{" "}
          <a href="/konto-loeschen" className="text-[#00E5FF]">Konto-Löschen-Seite</a> auf unserer
          Website. Mit der Löschung werden personenbezogene Daten gelöscht, soweit keine gesetzlichen
          Aufbewahrungspflichten entgegenstehen.
        </p>
      </Section>

      <Section title="16. Rechte der betroffenen Personen">
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Auskunft</li>
          <li>Berichtigung</li>
          <li>Löschung</li>
          <li>Einschränkung der Verarbeitung</li>
          <li>Datenübertragbarkeit</li>
          <li>Widerspruch</li>
          <li>Widerruf einer Einwilligung</li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte genügt eine E-Mail an{" "}
          <a href="mailto:privacy@festivalplan.app" className="text-[#00E5FF]">privacy@festivalplan.app</a>.
        </p>
      </Section>

      <Section title="17. Beschwerderecht">
        <p>
          Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung Ihrer
          personenbezogenen Daten zu beschweren.
        </p>
      </Section>

      <Section title="18. Minderjährige">
        <p>
          FestivalPlan richtet sich nicht gezielt an Kinder unter 16 Jahren. Personen unter 16 Jahren
          sollten die App nur mit Zustimmung ihrer Erziehungsberechtigten nutzen.
        </p>
      </Section>

      <Section title="19. Änderungen dieser Datenschutzerklärung">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn dies aufgrund neuer
          gesetzlicher Vorgaben oder technischer Änderungen erforderlich wird. Es gilt jeweils die auf
          unserer Website veröffentlichte aktuelle Version.
        </p>
      </Section>

      <Section title="20. Kontakt">
        <p>Bei Fragen zum Datenschutz erreichen Sie uns unter:</p>
        <p>Sebastian Menzel</p>
        <p>
          E-Mail: <a href="mailto:privacy@festivalplan.app" className="text-[#00E5FF]">privacy@festivalplan.app</a>
        </p>
      </Section>
    </LegalShell>
  );
}
